import script from "./DesignToolWidthModal.vue?vue&type=script&setup=true&lang=js"
export * from "./DesignToolWidthModal.vue?vue&type=script&setup=true&lang=js"

import "./DesignToolWidthModal.vue?vue&type=style&index=0&id=587cf181&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-587cf181"]])

export default __exports__